import SignUpInputForm from './SignUpInputForm';

export default SignUpInputForm;
